<template>
    <div>
        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <label>Дата начала периода</label>
                <date-component v-model="currFilters.dateFrom"/>
            </div>
            <div class="form-group">
                <label>Дата окончания периода</label>
                <date-component v-model="currFilters.dateTo"/>
            </div>
            <div class="form-group select2">
                <label>Район</label>
                <Select2 :options="districts" :settings="{multiple:true,language:'ru', allowClear: true}" placeholder="(Все)"
                         v-model="currFilters.districtIds"/>
            </div>
            <div class="form-group select2">
                <label>Форма собственности</label>
                <Select2 :options="opf" :settings="{multiple:true,language:'ru', allowClear: true}" placeholder="(Все)"
                         v-model="currFilters.opfIds" :disabled="currFilters.servicesMatch"/>
            </div>
            <div class="form-group select2">
                <label>Вид деятельности</label>
                <Select2 :options="kindActivities" :settings="{language:'ru', allowClear: true}" placeholder="(Не задано)"
                         v-model="currFilters.kindActivityId" v-on:select="kindActivityChanged"/>
            </div>
            <div class="form-group select2">
                <label>Тип организации</label>
                <Select2 :options="orgTypes" :settings="{multiple:true,language:'ru', allowClear: true}" placeholder="(Все)"
                         v-model="currFilters.orgTypeIds" :disabled="currFilters.servicesMatch"/>
            </div>
          <div class="form-group select2">
            <label>Наименование услуги</label>
            <Select2 :options="serviceTypes" :settings="{multiple:true,language:'ru', allowClear: true}" placeholder="(Все)"
                     v-model="currFilters.serviceTypeIds"/>
          </div>
          <div class="form-group">
            <Checkbox v-model="currFilters.servicesMatch"
                      :checked="currFilters.servicesMatch"
                      id="servicesMatch"
                      text="Услуги совпадают"
                      style="margin-top:40px"
                      v-on:click="servicesMatchChanged"
            />
          </div>
            <div v-show="mustShowEduLevel" class="form-group select2">
                <label>Уровень образования</label>
                <Select2 :options="eduLevels" :settings="{language:'ru', allowClear: true}" placeholder="(Не задано)"
                         v-model="currFilters.eduLevelId" v-on:select="loadClassKinds"/>
            </div>
            <div v-show="mustShowClassKinds" class="form-group select2">
                <label>Вид класса</label>
                <Select2 :options="classKinds" :settings="{language:'ru', allowClear: true}" placeholder="(Не задано)"
                         v-model="currFilters.classKindId"/>
            </div>
            <div class="form-group select2">
                <label>Возраст</label>
                <Select2 :options="ages" :settings="{language:'ru', allowClear: true}" placeholder="(Не задано)"
                         v-model="currFilters.age"/>
            </div>
        </div>

        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group select2">
              <div class="d-flex align-items-center">
                <label class="mr-2">Отобразить в отчете</label>
                <Checkbox v-model="fieldsChecked"
                          :checked="fieldsChecked"
                          id="fieldsSpec"
                          text="Все поля"
                />
              </div>
                <Select2 :options="fields" :settings="{multiple:true,language:'ru'}" placeholder="(Выберите поля)"
                         v-model="currFilters.fields"/>
            </div>
        </div>

        <div class="d-flex align-items-center filter-wrapper flex-wrap">
            <div class="form-group">
                <div class="card-footer px-0 d-flex">
                    <button-component @click="apply" class="btn-xs">Сформировать</button-component>
                    <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
                    <button class="btn-success btn-d btn-xs" @click="exportReport">
                        <i class="fa fa-download"></i>Экспорт</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DateComponent from "../../../common/components/DateComponent";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import NsiApi from "../../admin/api/nsi";
  import Api from "../api/routing";
  import Checkbox from "@/common/ui/checkbox";
  import Constants from "@/common/constants";
  export default {
    name: "ReportRoutingFilter",
    components: {Checkbox, ButtonComponent, DateComponent},
    props: {
      filters: Object
    },
    data() {
      return {
        fieldsChecked: true,
        districts: [],
        opf: [],
        kindActivities: [],
        orgTypes: [],
        serviceTypes: [],
        eduLevels: [],
        classKinds: [],
        ages: [
          {id: 'age1_7', text: '1-7 лет'},
          {id: 'age8_17', text: '8-17 лет'},
          {id: 'age_lte18', text: 'до 18 лет'},
          {id: 'age_gt18', text: 'от 18 лет'}
        ],
        fieldsSource: [],
        currFilters: this.filters,
        kindActivityEducation: Constants.KindActivityEducation
      }
    },
    created() {
      this.loadDictionaries();
    },
    methods: {
      loadDictionaries() {
        NsiApi.getNsi('district')
          .then((response) => {
            this.districts = response.data;
          });
        NsiApi.getNsi('opf', {parentId: -1})
          .then((response) => {
            this.opf = response.data;
          });
        NsiApi.getNsi('kindactivity')
          .then((response) => {
            this.kindActivities = response.data;
          });
        NsiApi.getNsi('educationlevel')
          .then((response) => {
            this.eduLevels = response.data;
          });

        Api.getReportFields()
          .then((response) => {
            this.fieldsSource = response.data.map((x) => ({id: x.name, text: x.title}));
            this.currFilters.fields = this.fields.map(item => item.id)
          });
      },
      loadOrgTypes() {
        NsiApi.getOrganizationTypes(this.currFilters.kindActivityId)
          .then((response) => {
            this.orgTypes = response.data;
          });
      },
      loadServiceTypes() {
        NsiApi.getServiceTypes(this.currFilters.kindActivityId)
            .then((response) => {
              this.serviceTypes = response.data;
            });
      },
      loadClassKinds() {
        NsiApi.getClassKinds(this.currFilters.eduLevelId)
          .then((response) => {
            this.classKinds = response.data;
          });
      },
      kindActivityChanged() {
        if (this.currFilters.kindActivityId) {
          this.loadOrgTypes();
          this.loadServiceTypes();
        } else {
          this.orgTypes = [];
          this.serviceTypes = [];
        }
      },
      servicesMatchChanged(e) {
        if (e.target.id === "servicesMatch" && e.target.checked) {
          this.currFilters.opfIds = [];
          this.currFilters.orgTypeIds = [];
          this.currFilters.fields = this.currFilters.fields.filter((id) => !(id === 'OpfName' || id === 'OrgTypeName'));
        }
      },
      apply() {
        this.$emit('apply', this.getFilter());
      },
      reset() {
        this.currFilters = {
          dateFrom: null,
          dateTo: null,
          districtIds: [],
          opfIds: [],
          orgTypeIds: [],
          serviceTypeIds: [],
          servicesMatch: false,
          eduLevelId: null,
          classKindId: null,
          age: null,
          fields: ['DistrictName', 'OpfName', 'TotalCount']
        };
        const filters = Object.assign({}, this.currFilters);
        this.$emit('reset', filters);
      },
      exportReport() {
        this.$emit('exportReport', this.getFilter());
      },
      getFilter() {
        return Object.assign({}, this.currFilters);
      }
    },
    watch: {
      fieldsChecked: {
        handler(val) {
          if(val === true) {
            this.currFilters.fields = this.fields.map(item => item.id)
          }
          if(val === false) {
            this.currFilters.fields = []
          }
        },
        deep: true
      },

    },
    computed: {
      mustShowEduLevel() {
        return Number(this.currFilters.kindActivityId) === this.kindActivityEducation;
      },
      mustShowClassKinds() {
        return Number(this.currFilters.kindActivityId) === this.kindActivityEducation &&
          this.allowedEducationLevels.indexOf(Number(this.currFilters.eduLevelId)) > -1;
      },
      allowedEducationLevels() {
        return [1, 2, 3, 4];
      },
      fields() {
        let result = this.fieldsSource.filter((x) => !(x.id === 'EduLevelName' || x.id === 'ClassKindName'));
        if (this.currFilters.servicesMatch) {
          result = result.filter((x) => !(x.id === 'OpfName' || x.id === 'OrgTypeName'));
        }
        if (this.mustShowEduLevel) {
          result.splice(result.length - 1, 0, this.fieldsSource.find((x) => x.id === 'EduLevelName'));
        }
        if (this.mustShowClassKinds) {
          result.splice(result.length - 1, 0, this.fieldsSource.find((x) => x.id === 'ClassKindName'));
        }
        return result;
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/theme/default/colors";

    .form-group {
        label {
            font-weight: 400 !important;
            color: $gray-dark;
            font-size: 16px;
        }
    }
    .filter-wrapper{
        div:not(:last-child){
            margin-right: 16px;
        }
    }
    .card-footer {
        padding-top: 36px;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }
    .btn-d{
        border: none;
        padding: 14px 24px;
        border-radius: 24px;
        i{
            padding-right: 12px;
        }
    }
</style>
